import React from 'react'
import './check-box.scss'

const CheckBox = props => {
    const changeCheck = props.changeCheck;
    const isChecked = props.isChecked;

    return (
        <div className="mdn-Checkbox mdn-u-floatRight" aria-label="checkbox">
            <input className="mdn-Checkbox-input" id="i1" type="checkbox" onChange={changeCheck} checked={isChecked} />
            <label className="mdn-Checkbox-label" htmlFor="i1"></label>
            <label className="mdn-Checkbox-text" htmlFor="i1"> Mostrar somente canais em HD</label>
        </div>
    )
}

export default CheckBox;